import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IReportTransactionResponse } from '@bciti/types';

@Injectable({
    providedIn: 'root',
})
export abstract class ReportsService {
    abstract getMonthReceiptsFromOrganisation(organisationTag: string, startDate: string, endDate: string): Observable<IReportTransactionResponse[]>;
    abstract getMonthReceiptsFromOrganisationCSV(organisationTag: string, startDate: string, endDate: string): Observable<IReportTransactionResponse[]>;
}
